export default "__VITE_ASSET__D$mU_ZGE__"